import { WorkerRequirementMappingLevel } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";

import {
  calculateMissingCredential,
  mapPlacementDetailRequirementsToPlacementDataRequirements,
} from "../../Documents/utils/calculateMissingCredential";
import { type PlacementDetail } from "../api/useGetPlacement";
import { shouldShowRequirement } from "../utils";

/**
 * Returns the list of missing documents for a placement, including both
 * worker requirements and the relevant credential requirement (if any).
 */
export function getMissingDocuments(placementDetails: PlacementDetail) {
  const missingWorkerRequirements =
    placementDetails.workerRequirements?.filter((requirement) =>
      shouldShowRequirement(requirement)
    ) ?? [];
  const missingCredentialRequirements =
    placementDetails.credentialRequirements?.filter((requirement) =>
      shouldShowRequirement(requirement)
    ) ?? [];

  const missingCredentialType = calculateMissingCredential(
    mapPlacementDetailRequirementsToPlacementDataRequirements(missingCredentialRequirements)
  );

  const missingCredentialRequirement =
    missingCredentialType === "BASE_CREDENTIAL"
      ? missingCredentialRequirements.find(
          (requirement) => requirement.attributes.level === WorkerRequirementMappingLevel.STATE
        )
      : missingCredentialRequirements.find(
          (requirement) => requirement.attributes.level === WorkerRequirementMappingLevel.HCF
        );

  return [
    ...missingWorkerRequirements,
    ...(isDefined(missingCredentialRequirement) ? [missingCredentialRequirement] : []),
  ];
}
